import apiService from "@/core/services/apiService";

export type State = { classes: object };
import {Module, VuexModule, Mutation, Action} from "vuex-module-decorators";
import {Actions, Mutations} from "@/store/enums/store.enums";
import {ConfiguratorActions, ConfiguratorMutation} from "@/modules/configurator/store/enums";
import store from "@/store";

@Module
export default class Store extends VuexModule {
    renderKey = 1;

    // images list //
    imagesListParams = {
        page: 1,
        results: 5,
        search: null,
        sort: [],
        filter: {}
    };
    imagesListCache = [];
    imagesListTotal = 0;

    // blacklist list //
    blacklistListParams = {
        page: 1,
        results: 5,
        search: null,
        sort: [],
        filter: {}
    };
    blacklistListCache = [];
    blacklistListTotal = 0;

    // settings list //
    settingsListParams = {
        page: 1,
        results: 25,
        search: null,
        sort: [],
        filter: {}
    };
    settingsListCache = [];
    settingsListTotal = 0;

    // sponsors list //
    sponsorsListParams = {
        page: 1,
        results: 5,
        search: null,
        sort: [],
        filter: {}
    };
    sponsorsListCache = [];
    sponsorsListTotal = 0;

    // options list //
    optionsListParams = {
        page: 1,
        results: 5,
        search: null,
        sort: [],
        filter: {}
    };
    optionsListCache = [];
    optionsListTotal = 0;

    // brands list //
    brandsListParams = {
        page: 1,
        results: 5,
        search: null,
        sort: [],
        filter: {}
    };
    brandsListCache = [];
    brandsListTotal = 0;

    // age groups list //
    ageGroupsListParams = {
        page: 1,
        results: 5,
        search: null,
        sort: [],
        filter: {}
    };
    ageGroupsListCache = [];
    ageGroupsListTotal = 0;

    // sport filters list //
    sportFiltersListParams = {
        page: 1,
        results: 5,
        search: null,
        sort: [],
        filter: {}
    };
    sportFiltersListCache = [];
    sportFiltersListTotal = 0;

    // delivery countries list //
    deliveryCountriesListParams = {
        page: 1,
        results: 5,
        search: null,
        sort: [],
        filter: {}
    };
    deliveryCountriesListCache = [];
    deliveryCountriesListTotal = 0;

    // products list //
    productsListParams = {
        page: 1,
        results: 5,
        search: null,
        sort: [],
        filter: {}
    };
    productsListCache = [];
    productsListTotal = 0;

    trackingListParams = {
        page: 1,
        results: 5,
        search: null,
        sort: [],
        filter: {}
    };
    trackingListCache = [];
    trackingListTotal = 0;

    // orders list //
    ordersListParams = {
        page: 1,
        results: 5,
        search: null,
        sort: [],
        filter: {}
    };
    ordersListCache = [];
    ordersListTotal = 0;

    get getConfiguratorRenderKey() {
        return 'configurator-' + this.renderKey;
    }

    get getConfiguratorImagesLastListResult() {
        return this.imagesListCache;
    }

    get getConfiguratorImagesLastListTotal() {
        return this.imagesListTotal;
    }

    get getConfiguratorBlacklistLastListResult() {
        return this.blacklistListCache;
    }

    get getConfiguratorBlacklistLastListTotal() {
        return this.blacklistListTotal;
    }

    get getConfiguratorSettingsLastListResult() {
        return this.settingsListCache;
    }

    get getConfiguratorSettingsLastListTotal() {
        return this.settingsListTotal;
    }

    get getConfiguratorSponsorsLastListResult() {
        return this.sponsorsListCache;
    }

    get getConfiguratorSponsorsLastListTotal() {
        return this.sponsorsListTotal;
    }

    get getConfiguratorOptionsLastListResult() {
        return this.optionsListCache;
    }

    get getConfiguratorOptionsLastListTotal() {
        return this.optionsListTotal;
    }

    get getConfiguratorBrandsLastListResult() {
        return this.brandsListCache;
    }

    get getConfiguratorBrandsLastListTotal() {
        return this.brandsListTotal;
    }

    get getConfiguratorAgeGroupsLastListResult() {
        return this.ageGroupsListCache;
    }

    get getConfiguratorAgeGroupsLastListTotal() {
        return this.ageGroupsListTotal;
    }

    get getConfiguratorSportFiltersLastListResult() {
        return this.sportFiltersListCache;
    }

    get getConfiguratorSportFiltersLastListTotal() {
        return this.sportFiltersListTotal;
    }

    get getConfiguratorDeliveryCountriesLastListResult() {
        return this.deliveryCountriesListCache;
    }

    get getConfiguratorDeliveryCountriesLastListTotal() {
        return this.deliveryCountriesListTotal;
    }

    get getConfiguratorProductsLastListResult() {
        return this.productsListCache;
    }

    get getConfiguratorProductsLastListTotal() {
        return this.productsListTotal;
    }

    get getConfiguratorProductsLastListParams() {
        return this.productsListParams;
    }

    get getConfiguratorTrackingLastListResult() {
        return this.trackingListCache;
    }

    get getConfiguratorTrackingLastListTotal() {
        return this.trackingListTotal;
    }

    get getConfiguratorOrdersLastListResult() {
        return this.ordersListCache;
    }

    get getConfiguratorOrdersLastListTotal() {
        return this.ordersListTotal;
    }

    get getConfiguratorOrdersLastListParams() {
        return this.ordersListParams;
    }

    get getConfiguratorProductsMappingFields() {
        return {
            masterId: {
                required: true,
                label: 'Master ID',
                mapping: null,
                unique: false,
                duplicates: null,
                options: null,
                optionsMapped: {}
            },
            nameDe: {
                required: false,
                label: 'Name (DE)',
                mapping: null,
                unique: false,
                duplicates: null,
                options: null,
                optionsMapped: {}
            },
            variantId: {
                required: true,
                label: 'Varianten ID',
                mapping: null,
                unique: true,
                duplicates: 'skip',
                options: null,
                optionsMapped: {}
            },
            vk: {
                required: false,
                label: 'VK (Preis)',
                mapping: null,
                unique: false,
                duplicates: null,
                options: null,
                optionsMapped: {}
            },
            uvp: {
                required: false,
                label: 'UVP',
                mapping: null,
                unique: false,
                duplicates: null,
                options: null,
                optionsMapped: {}
            },
            ageGroup: {
                required: false,
                label: 'Altersgruppe',
                mapping: null,
                unique: false,
                duplicates: null,
                options: null,
                optionsMapped: {}
            },
        };
    }

    @Mutation
    [ConfiguratorMutation.SET_RENDER_UPDATE]() {
        this.renderKey++;
    }

    @Mutation
    [ConfiguratorMutation.SET_IMAGES_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.imagesListParams = listParams;
        this.imagesListCache = listCache;
        this.imagesListTotal = listTotal;
    }

    @Mutation
    [ConfiguratorMutation.SET_BLACKLIST_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.blacklistListParams = listParams;
        this.blacklistListCache = listCache;
        this.blacklistListTotal = listTotal;
    }

    @Mutation
    [ConfiguratorMutation.SET_SETTINGS_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.settingsListParams = listParams;
        this.settingsListCache = listCache;
        this.settingsListTotal = listTotal;
    }

    @Mutation
    [ConfiguratorMutation.SET_SPONSORS_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.sponsorsListParams = listParams;
        this.sponsorsListCache = listCache;
        this.sponsorsListTotal = listTotal;
    }

    @Mutation
    [ConfiguratorMutation.SET_OPTIONS_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.optionsListParams = listParams;
        this.optionsListCache = listCache;
        this.optionsListTotal = listTotal;
    }

    @Mutation
    [ConfiguratorMutation.SET_BRANDS_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.brandsListParams = listParams;
        this.brandsListCache = listCache;
        this.brandsListTotal = listTotal;
    }

    @Mutation
    [ConfiguratorMutation.SET_AGE_GROUPS_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.ageGroupsListParams = listParams;
        this.ageGroupsListCache = listCache;
        this.ageGroupsListTotal = listTotal;
    }

    @Mutation
    [ConfiguratorMutation.SET_SPORT_FILTERS_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.sportFiltersListParams = listParams;
        this.sportFiltersListCache = listCache;
        this.sportFiltersListTotal = listTotal;
    }

    @Mutation
    [ConfiguratorMutation.SET_DELIVERY_COUNTRIES_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.deliveryCountriesListParams = listParams;
        this.deliveryCountriesListCache = listCache;
        this.deliveryCountriesListTotal = listTotal;
    }

    @Mutation
    [ConfiguratorMutation.SET_PRODUCTS_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.productsListParams = listParams;
        this.productsListCache = listCache;
        this.productsListTotal = listTotal;
    }

    @Mutation
    [ConfiguratorMutation.SET_TRACKING_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.trackingListParams = listParams;
        this.trackingListCache = listCache;
        this.trackingListTotal = listTotal;
    }

    @Mutation
    [ConfiguratorMutation.SET_ORDERS_LIST_RESULT]({listParams, listTotal, listCache}) {
        this.ordersListParams = listParams;
        this.ordersListCache = listCache;
        this.ordersListTotal = listTotal;
    }

    // ==========================================
    // Images Actions
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_IMAGES_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_IMAGES_LIST, this.imagesListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_IMAGES_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/images-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_IMAGES_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.GET_IMAGE](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/images-get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_IMAGE](payload) {

        return new Promise((resolve, reject) => {

            const { editId, data: entryData } = payload;

            apiService.put(`configurator/images-edit/${editId}`, entryData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_IMAGES_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.DELETE_IMAGE](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`configurator/images-delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_IMAGES_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.SYNC_IMAGES](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('pico/sync-images', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_IMAGES_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPLOAD_IMAGES](formData) {

        return new Promise((resolve, reject) => {

            apiService.post('configurator/images-upload', formData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_IMAGES_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ==========================================
    // Blacklist Actions
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_BLACKLIST_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_BLACKLIST_LIST, this.blacklistListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_BLACKLIST_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/blacklist-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_BLACKLIST_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.GET_BLACKLIST](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/blacklist-get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.CREATE_BLACKLIST](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('configurator/blacklist-create', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_BLACKLIST_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_BLACKLIST](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data: entryData} = payload;

            apiService.put(`configurator/blacklist-edit/${editId}`, entryData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_BLACKLIST_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.DELETE_BLACKLIST](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`configurator/blacklist-delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_BLACKLIST_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ==========================================
    // Settings Actions
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_SETTINGS_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_SETTINGS_LIST, this.settingsListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_SETTINGS_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/settings-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_SETTINGS_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.GET_SETTING](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/settings-get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.CREATE_SETTING](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('configurator/settings-create', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_SETTINGS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_SETTING](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data: entryData} = payload;

            apiService.put(`configurator/settings-update/${editId}`, entryData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_SETTINGS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.DELETE_SETTING](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`configurator/settings-delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_SETTINGS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.DUPLICATE_SETTING](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data: entryData} = payload;

            apiService.post(`configurator/settings-duplicate/${editId}`, entryData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_SETTINGS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.EXPORT_SETTING](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/settings-export/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.IMPORT_SETTING](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('configurator/settings-import', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_SETTINGS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ==========================================
    // Sponsors Actions
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_SPONSORS_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_SPONSORS_LIST, this.sponsorsListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_SPONSORS_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/sponsors-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_SPONSORS_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.GET_SPONSOR](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/sponsors-get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.CREATE_SPONSOR](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('configurator/sponsors-create', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_SPONSORS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_SPONSOR](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data: entryData} = payload;

            apiService.put(`configurator/sponsors-edit/${editId}`, entryData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_SPONSORS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.DELETE_SPONSOR](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`configurator/sponsors-delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_SPONSORS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ==========================================
    // Options Actions
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_OPTIONS_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_OPTIONS_LIST, this.optionsListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_OPTIONS_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/options-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_OPTIONS_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.GET_OPTION](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/options-get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.CREATE_OPTION](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('configurator/options-create', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_OPTIONS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_OPTION](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data: entryData} = payload;

            apiService.put(`configurator/options-edit/${editId}`, entryData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_OPTIONS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.DELETE_OPTION](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`configurator/options-delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_OPTIONS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ==========================================
    // Brands Actions
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_BRANDS_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_BRANDS_LIST, this.brandsListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_BRANDS_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/brands-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_BRANDS_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.GET_BRAND](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/brands-get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.CREATE_BRAND](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('configurator/brands-create', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_BRANDS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_BRAND](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data: entryData} = payload;

            apiService.put(`configurator/brands-edit/${editId}`, entryData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_BRANDS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.DELETE_BRAND](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`configurator/brands-delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_BRANDS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ==========================================
    // Age Groups Actions
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_AGE_GROUPS_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_AGE_GROUPS_LIST, this.ageGroupsListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_AGE_GROUPS_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/age-groups-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_AGE_GROUPS_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.GET_AGE_GROUP](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/age-groups-get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.CREATE_AGE_GROUP](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('configurator/age-groups-create', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_AGE_GROUPS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_AGE_GROUP](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data: entryData} = payload;

            apiService.put(`configurator/age-groups-edit/${editId}`, entryData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_AGE_GROUPS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.DELETE_AGE_GROUP](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`configurator/age-groups-delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_AGE_GROUPS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ==========================================
    // Sport Filters Actions
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_SPORT_FILTERS_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_SPORT_FILTERS_LIST, this.sportFiltersListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_SPORT_FILTERS_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/sport-filters-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_SPORT_FILTERS_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.GET_SPORT_FILTER](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/sport-filters-get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.CREATE_SPORT_FILTER](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('configurator/sport-filters-create', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_SPORT_FILTERS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_SPORT_FILTER](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data: entryData} = payload;

            apiService.put(`configurator/sport-filters-edit/${editId}`, entryData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_SPORT_FILTERS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.DELETE_SPORT_FILTER](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`configurator/sport-filters-delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_SPORT_FILTERS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ==========================================
    // Delivery Countries Actions
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_DELIVERY_COUNTRIES_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_DELIVERY_COUNTRIES_LIST, this.deliveryCountriesListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_DELIVERY_COUNTRIES_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/delivery-countries-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_DELIVERY_COUNTRIES_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.GET_DELIVERY_COUNTRY](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/delivery-countries-get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.CREATE_DELIVERY_COUNTRY](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('configurator/delivery-countries-create', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_DELIVERY_COUNTRIES_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_DELIVERY_COUNTRY](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data: entryData} = payload;

            apiService.put(`configurator/delivery-countries-edit/${editId}`, entryData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_DELIVERY_COUNTRIES_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.DELETE_DELIVERY_COUNTRY](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`configurator/delivery-countries-delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_DELIVERY_COUNTRIES_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ==========================================
    // Products Actions
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_PRODUCTS_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_PRODUCTS_LIST, this.productsListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_PRODUCTS_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/products-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_PRODUCTS_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.GET_PRODUCT](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/products-get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.CREATE_PRODUCT](payload) {

        return new Promise((resolve, reject) => {

            apiService.post('configurator/products-create', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_PRODUCTS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_PRODUCT](payload) {

        return new Promise((resolve, reject) => {

            const {editId, data: entryData} = payload;

            apiService.put(`configurator/products-edit/${editId}`, entryData).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_PRODUCTS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.DELETE_PRODUCT](editId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`configurator/products-delete/${editId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.dispatch(ConfiguratorActions.REFRESH_PRODUCTS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.IMPORT_PRODUCTS](payload) {

        return new Promise((resolve, reject) => {

            apiService.put('configurator/products-import', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_RENDER_UPDATE);
                this.context.dispatch(ConfiguratorActions.REFRESH_PRODUCTS_LIST);
                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.FETCH_PRODUCTS_PICKER](payload) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/products-picker", payload).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ==========================================
    // Tracking
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_TRACKING_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_TRACKING_LIST, this.trackingListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_TRACKING_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/tracking-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_TRACKING_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.FETCH_TRACKING_DETAIL](settingCode) {

        return new Promise((resolve, reject) => {

            apiService.post("configurator/tracking-detail/" + settingCode, {}).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    // ==========================================
    // Orders
    // ==========================================

    @Action
    [ConfiguratorActions.REFRESH_ORDERS_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_ORDERS_LIST, this.ordersListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_ORDERS_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/orders-list", params).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_ORDERS_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.GET_ORDER](id) {

        return new Promise((resolve, reject) => {

            apiService.get("configurator/orders-get/" + id).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.EXPORT_ORDER_CSV](id) {

        return new Promise((resolve, reject) => {

            apiService.get("configurator/orders-export-csv/" + id).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.EXPORT_ORDER_JSON](id) {

        return new Promise((resolve, reject) => {

            apiService.get("configurator/orders-export-json/" + id).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_ORDER](payload: { id: number; patch: Record<string, any> }) {

        return new Promise((resolve, reject) => {

            apiService.post("configurator/orders-update/" + payload.id, payload.patch).then((response) => {

                const data = response.data || null;

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                resolve(data.result);

            }).catch((response) => {

                this.context.commit(Mutations.SET_ERROR, response);
                reject();

            });

        });

    };


    // ==========================================
    // Unlock Codes
    // ==========================================

    unlockCodesListParams = { page: 1, results: 5, search: null, sort: {}, filter: {} };
    unlockCodesListTotal = 0;
    unlockCodesListCache = [];

    get getConfiguratorUnlockCodesLastListResult() {
        return this.unlockCodesListCache;
    }

    get getConfiguratorUnlockCodesLastListTotal() {
        return this.unlockCodesListTotal;
    }

    get getConfiguratorUnlockCodesLastListParams() {
        return this.unlockCodesListParams;
    }

    @Mutation
    [ConfiguratorMutation.SET_UNLOCK_CODES_LIST_RESULT](payload) {
        this.unlockCodesListParams = payload.listParams;
        this.unlockCodesListTotal = payload.listTotal;
        this.unlockCodesListCache = payload.listCache;
    }

    @Action
    [ConfiguratorActions.REFRESH_UNLOCK_CODES_LIST]() {
        this.context.dispatch(ConfiguratorActions.FETCH_UNLOCK_CODES_LIST, this.unlockCodesListParams);
    }

    @Action
    [ConfiguratorActions.FETCH_UNLOCK_CODES_LIST](params) {

        return new Promise<void>((resolve, reject) => {

            apiService.post("configurator/unlock-codes-list", params).then((response) => {

                const data = response.data || null;
                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }

                this.context.commit(ConfiguratorMutation.SET_UNLOCK_CODES_LIST_RESULT, {
                    listParams: params,
                    listTotal: data.results,
                    listCache: data.result
                });
                resolve();

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ConfiguratorActions.GET_UNLOCK_CODE](detailId) {

        return new Promise<void>((resolve, reject) => {

            apiService.get(`configurator/unlock-codes-get/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ConfiguratorActions.CREATE_UNLOCK_CODE](params) {

        return new Promise((resolve, reject) => {

            apiService.post("configurator/unlock-codes-create", params).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ConfiguratorActions.UPDATE_UNLOCK_CODE](payload) {

        return new Promise((resolve, reject) => {

            apiService.put(`configurator/unlock-codes-edit/${payload.editId}`, payload.data).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    @Action
    [ConfiguratorActions.DELETE_UNLOCK_CODE](detailId) {

        return new Promise((resolve, reject) => {

            apiService.delete(`configurator/unlock-codes-delete/${detailId}`).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.result);

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

    // Bulk-Import aus CSV. Nutzt dasselbe Widget-Payload-Format wie
    // Customers/Items (headerLine + mappedFields + importFile). Das Backend
    // übernimmt das Zeilen-Parsing und die Unlock-Data-Zusammensetzung —
    // hier nur POST + Report-Resolve.
    @Action
    [ConfiguratorActions.IMPORT_UNLOCK_CODES](payload) {

        return new Promise((resolve, reject) => {

            apiService.put('configurator/unlock-codes-import', payload).then(({data}) => {

                const _verified = apiService.verifyApiResult(data);
                if (!_verified) {
                    this.context.commit(Mutations.SET_ERROR, data);
                    return reject();
                }
                resolve(data.report || data.result || {});

            }).catch((response) => {
                this.context.commit(Mutations.SET_ERROR, response);
                reject();
            });

        });

    };

}
